import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header/Header';
import PageTitle from '../../components/pagetitle/PageTitle';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/business/Footer/Footer';
import CtaSection from '../../components/CtaSection/CtaSection';
import { Accordion, AccordionItem, AccordionHeader, AccordionBody } from 'reactstrap';
import Bg from '../../images/backgrounds/onze_diensten_image.webp';
import Shape from '../../images/shapes/shape_title_under_line.svg';
import srImg from '../../images/services/quickscan/quickscan_info.webp';

const AwarenessTraining = (props) => {
    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        open === id ? setOpen('') : setOpen(id);
    };

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <PageTitle pageTitle={'Awareness Training'} bgImage={Bg} />

                {/* Introductie Section */}
                <section className="about_section section_space bg-light">
                    <div className="container">
                        <div className="row align-items-center justify-content-lg-between">
                            <div className="col-lg-5 order-lg-last">
                                <div className="team_cartoon_image">
                                    <img src={srImg} alt="Service Cartoon"/>
                                </div>
                            </div>
                            <div className="col-lg-5">
                                <div className="about_content">
                                    <div className="heading_block">
                                        <h2 className="heading_text">
                                            Plan Jouw Cybersecurity Awareness Training
                                        </h2>
                                        <p className="heading_description mb-0">
                                            Bescherm jouw organisatie tegen cyberdreigingen met op maat gemaakte awareness training. Bij Praeventor bieden we interactieve sessies die zijn ontworpen om je team bewust te maken van de laatste beveiligingsrisico’s en hen praktische vaardigheden bij te brengen. Plan hieronder jouw training en versterk de cyberweerbaarheid van je team op een manier die past bij jouw schema.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Voordelen Section */}
                <section className="benefits_section section_space">
                    <div className="container">
                        <div className="heading_block text-center">
                            <h3 className="heading_text">Wat levert de Awareness Training jouw team op?</h3>
                            <p className="heading_description mb-5">Onze training is gericht op het vergroten van kennis en het versterken van cybersecurity-bewustzijn binnen jouw organisatie.</p>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="benefit_card card">
                                    <div className="card-body">
                                        <h4 className="card-title">Bewustwording</h4>
                                        <p className="card-text">Medewerkers leren veelvoorkomende bedreigingen herkennen, zoals phishing en social engineering, en hoe deze te vermijden.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="benefit_card card">
                                    <div className="card-body">
                                        <h4 className="card-title">Veilige gewoontes</h4>
                                        <p className="card-text">Ons programma bevordert veilige digitale gewoontes, zoals veilig wachtwoordgebruik en gegevensbeheer.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="benefit_card card">
                                    <div className="card-body">
                                        <h4 className="card-title">Verhoogde waakzaamheid</h4>
                                        <p className="card-text">Creëer een ‘security-first’-cultuur waarbij medewerkers alert zijn op verdachte activiteiten en risico's.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Stappenplan Inplannen Training */}
                <section className="steps_section section_decoration bg-light mt-5 pt-5" style={{ paddingBottom: "150px" }}>
                    <div className="container">
                        <div className="heading_block text-center">
                            <h3 className="heading_text">Hoe Werkt Het?</h3>
                            <p className="heading_description mb-5">In slechts enkele eenvoudige stappen plan je jouw awareness training.</p>
                        </div>
                        <div className="row">
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="step_card card">
                                    <div className="card-body text-center">
                                        <h4 className="card-title">1. Kies Datum & Tijd</h4>
                                        <p className="card-text">Ga in contact met onze experts wanneer wij bij jullie langs kunnen komen!</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="step_card card">
                                    <div className="card-body text-center">
                                        <h4 className="card-title">2. Kies Type Training</h4>
                                        <p className="card-text">Kies tussen de 2-uur basis training of de 6-uur uitgebreide training.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="step_card card">
                                    <div className="card-body text-center">
                                        <h4 className="card-title">3. Vul Bedrijfsgegevens In</h4>
                                        <p className="card-text">Laat ons weten hoeveel deelnemers er zijn en eventuele specifieke wensen.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 mb-4">
                                <div className="step_card card">
                                    <div className="card-body text-center">
                                        <h4 className="card-title">4. Bevestig Boeking</h4>
                                        <p className="card-text">Na bevestiging ontvang je een e-mail met alle details van de training.</p>
                                    </div>
                                </div>
                            </div>
                            <div className="text-center col-lg-12 col-md-12 mb-4">
                                <Link onClick={ClickHandler} to={'/contact'} className="btn">
                                    <span className="btn_label" data-text="Praat met een expert">Praat met een expert</span>
                                    <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                </Link>
                            </div>

                        </div>
                    </div>
                </section>

                {/* FAQ Section */}
                <section className="faq_section section_decoration" style={{ paddingBottom: "150px" }}>
                    <div className="container">
                        <div className="heading_block text-center">
                            <div className="heading_focus_text has_underline d-inline-flex" style={{ backgroundImage: `url(${Shape})` }}>
                                F.A.Q.
                            </div>
                            <h2 className="heading_text mb-0">
                                Veelgestelde Vragen
                            </h2>
                        </div>

                        <div className="faq_accordion accordion" id="faq_accordion">
                            <Accordion open={open} toggle={toggle} className="accordion" id="service_process_faq">
                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="1">
                                        Q. Wat als ik de training moet verplaatsen?
                                    </AccordionHeader>
                                    <AccordionBody accordionId="1" className='acc_body'>
                                        <div className="text_a">A.</div>
                                        <p>
                                            Neem contact met ons op en we kunnen een nieuwe datum en tijd inplannen die beter uitkomt.
                                        </p>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="2">
                                        Q. Is er een maximum aantal deelnemers?
                                    </AccordionHeader>
                                    <AccordionBody accordionId="2" className='acc_body'>
                                        <div className="text_a">A.</div>
                                        <p>
                                            Onze trainingen zijn ontworpen voor groepen van alle formaten. Voor grotere groepen kunnen we speciale sessies regelen.
                                        </p>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="3">
                                        Q. Hoe werkt de online training?
                                    </AccordionHeader>
                                    <AccordionBody accordionId="3" className='acc_body'>
                                        <div className="text_a">A.</div>
                                        <p>
                                            We gebruiken een beveiligd platform voor online trainingen. Voorafgaand aan de training sturen we een link en inloginstructies.
                                        </p>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className="accordion-item">
                                    <AccordionHeader targetId="4">
                                        Q. Kunnen we de training aanpassen voor ons bedrijf?
                                    </AccordionHeader>
                                    <AccordionBody accordionId="4" className='acc_body'>
                                        <div className="text_a">A.</div>
                                        <p>
                                            Ja, we kunnen de training afstemmen op specifieke risico's en thema’s die voor jouw bedrijf relevant zijn.
                                        </p>
                                    </AccordionBody>
                                </AccordionItem>
                            </Accordion>
                        </div>
                    </div>
                </section>

                <CtaSection />
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    );
};

export default AwarenessTraining;
